"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layers = require("../../layers");

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

var _MenuDivider = _interopRequireDefault(require("./MenuDivider"));

var _MenuGroup = _interopRequireDefault(require("./MenuGroup"));

var _MenuOption = _interopRequireDefault(require("./MenuOption"));

var _MenuOptionsGroup = _interopRequireDefault(require("./MenuOptionsGroup"));

var KeyCodes = {
  ArrowUp: 38,
  ArrowDown: 40,
  Home: 36,
  End: 35
};

var Menu =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Menu, _React$PureComponent);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMenuRef", function (ref) {
      _this.menuRef = ref;
    });
    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Get the menu item buttons
      // eslint-disable-next-line unicorn/prefer-spread
      this.menuItems = Array.from(this.menuRef.querySelectorAll('[role="menuitemradio"], [role="menuitem"]'));

      if (this.menuItems.length === 0) {
        throw new Error('The menu has no menu items');
      }

      this.firstItem = this.menuItems[0];
      this.lastItem = this.menuItems[this.menuItems.length - 1];

      var focusNext = function focusNext(currentItem, startItem) {
        // Determine which item is the startItem (first or last)
        var goingDown = startItem === _this2.firstItem; // Helper function for getting next legitimate element

        var move = function move(elem) {
          var indexOfItem = _this2.menuItems.indexOf(elem);

          if (goingDown) {
            if (indexOfItem < _this2.menuItems.length - 1) {
              return _this2.menuItems[indexOfItem + 1];
            }

            return startItem;
          }

          if (indexOfItem - 1 > -1) {
            return _this2.menuItems[indexOfItem - 1];
          }

          return startItem;
        }; // Make first move


        var nextItem = move(currentItem); // If the menuitem is disabled move on

        while (nextItem.disabled) {
          nextItem = move(nextItem);
        } // Focus the first one that's not disabled


        nextItem.focus();
      };

      this.menuItems.forEach(function (menuItem) {
        // Handle key presses for menuItem
        menuItem.addEventListener('keydown', function (e) {
          // Go to next/previous item if it exists
          // or loop around
          if (e.keyCode === KeyCodes.ArrowDown) {
            e.preventDefault();
            focusNext(menuItem, _this2.firstItem);
          }

          if (e.keyCode === KeyCodes.ArrowUp) {
            e.preventDefault();
            focusNext(menuItem, _this2.lastItem);
          }

          if (e.keyCode === KeyCodes.Home) {
            e.preventDefault();

            _this2.firstItem.focus();
          }

          if (e.keyCode === KeyCodes.End) {
            e.preventDefault();

            _this2.lastItem.focus();
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react.default.createElement(_layers.Pane, {
        is: "nav",
        innerRef: this.onMenuRef,
        role: "menu",
        outline: "none"
      }, children);
    }
  }]);
  return Menu;
}(_react.default.PureComponent);

exports.default = Menu;
Menu.displayName = "Menu";
(0, _defineProperty2.default)(Menu, "Item", _MenuItem.default);
(0, _defineProperty2.default)(Menu, "Divider", _MenuDivider.default);
(0, _defineProperty2.default)(Menu, "Group", _MenuGroup.default);
(0, _defineProperty2.default)(Menu, "Option", _MenuOption.default);
(0, _defineProperty2.default)(Menu, "OptionsGroup", _MenuOptionsGroup.default);
(0, _defineProperty2.default)(Menu, "propTypes", {
  /**
   * The children of the component.
   */
  children: _propTypes.default.node
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/menu/src/Menu.js
// module id = 167
// module chunks = 0